import React, { useEffect } from "react";
import get from "lodash/get";
import { useSelector } from "react-redux";

const loadTaboolaScript = (type, url) => {
  if (document.getElementById("tb_loader_script")) return null;

  window._taboola = window._taboola || [];
  _taboola.push({
    // eslint-disable-line
    [type]: "auto",
    tracking: "utm_referrer=taboola"
  });

  const script = document.createElement("script");
  script.src = url;
  script.id = "tb_loader_script";
  script.defer = true;
  document.head.appendChild(script);

  if (window.performance && typeof window.performance.mark === "function") {
    window.performance.mark("tbl_ic");
  }

  window._taboola = window._taboola || [];
};

const removeTaboolaScript = () => {
  const script = document.getElementById("tb_loader_script");
  if (script && document) document.head.removeChild(script);
};

const TaboolaScript = ({ type }) => {
  const enableTaboola = useSelector((state) =>
    get(state, ["qt", "config", "publisher-attributes", "enable_taboola"], false)
  );
  const taboolaSrc = useSelector((state) => get(state, ["qt", "config", "publisher-attributes", "taboola_script"], ""));

  useEffect(() => enableTaboola && loadTaboolaScript(type, taboolaSrc), []);

  return <></>;
};

export default TaboolaScript;
